// FILE: src/components/student/lessons.js
// Merge the course resources with the student's progress into rows the
// dashboard can show. Unlock state comes from the server (B-10, WP-5).
export function mergeLessons(resources = [], viewed = [], idKey = "chapterId") {
  const rows = (resources || []).map((r, index) => {
    const record = (viewed || []).find((v) => v[idKey] === r._id);
    const slides = Array.isArray(record?.slides) ? record.slides : [];
    const completedSlides = slides.filter((s) => s.completed).length;
    // Slides the server has recorded at all (a slide shown in the player is
    // recorded with completed: false until its minimum time is reached).
    const viewedSlides = slides.length;
    const totalSlides = r.totalSlides || r.slides?.length || 0;
    return {
      ...r,
      index,
      completedSlides,
      viewedSlides,
      totalSlides,
      completed: !!record?.completed,
      completedAt: record?.completedAt || null,
      finalScore: record?.finalScore || 0,
      timeSpentSec: record?.timeSpentSec || 0
    };
  });
  // The server decides (WP-5, MTO 13.1): `locked`, with the `prerequisite`
  // to finish first. Only if a response has no `locked` field at all does
  // the old rule apply (previous item's slides all done).
  return rows.map((row, i) => {
    const prev = rows[i - 1];
    const unlocked =
      typeof row.locked === "boolean" ? !row.locked : i === 0 || (prev && prev.completedSlides >= prev.totalSlides);
    return { ...row, unlocked, status: lessonStatus({ ...row, unlocked }) };
  });
}

/**
 * Started = the student opened it: the server recorded a slide (even one not
 * yet completed), credited time or a score on it — the same rule as the
 * admin side (backend src/services/studentStatus.js, MTO 9.8 / 11.1).
 */
export function lessonStarted(row) {
  return (row.viewedSlides || 0) > 0 || (row.completedSlides || 0) > 0 || (row.timeSpentSec || 0) > 0 || (row.finalScore || 0) > 0;
}

export function lessonStatus(row) {
  if (!row.unlocked) return "locked";
  if (row.completed || (row.totalSlides > 0 && row.completedSlides >= row.totalSlides)) return "completed";
  if (lessonStarted(row)) return "in-progress";
  return "not-started";
}

export function lessonPercent(row) {
  if (!row.totalSlides) return row.status === "completed" ? 100 : 0;
  return Math.max(0, Math.min(100, (row.completedSlides / row.totalSlides) * 100));
}

/** The lesson to continue: the first unlocked one that isn't finished. */
export function nextLesson(rows) {
  return rows.find((r) => r.unlocked && r.status !== "completed") || null;
}

export const STATUS_LABEL = {
  locked: "Locked",
  completed: "Completed",
  "in-progress": "In progress",
  "not-started": "Not started"
};

export function actionLabel(status) {
  if (status === "completed") return "Review";
  if (status === "in-progress") return "Resume";
  return "Start";
}
